import React, { useContext, useEffect } from 'react'
import { Link } from 'react-router-dom'
import { GlobalState } from '../../../GlobalState';
import { TabTitle } from '../../../util/titleChanger'
import { toast, ToastContainer } from 'react-toastify';
import Loading from '../../../util/Loading';
import { deleteCategory } from '../../../action';
import ReactPaginate from 'react-paginate'

export default function CategoryDashboard() {
    TabTitle("Category Dashboard");
    const state = useContext(GlobalState)
    const [categories] = state.categoryAPI.categories;
    const signInUser = JSON.parse(localStorage.getItem("user_data"));

    //Local state
    const [rowPerPage] = state.categoryAPI.rowPerPage;
    const [pageNumber, setPageNumber] = state.categoryAPI.pageNumber;
    const [totalPages] = state.categoryAPI.totalPages;
    const [setSearch] = state.categoryAPI.search;
    const [callback, setCallback] = state.categoryAPI.callback;

    useEffect(() => { }, [rowPerPage, categories, pageNumber, totalPages])

    const pageNumberHandler = (data) => {
        let newPageNumber = data.selected + 1;
        setPageNumber(newPageNumber)
    }

    const searchHandler = (e) => {
        e.preventDefault();
        setPageNumber(1);
        setSearch(e.target.value ? e.target.value : "");
    }

    const deleteCategoryHandler = (id) => {
        deleteCategory(id, signInUser.id, res => {
            if (res.status === 200) {
                toast.success(res.data);
                setCallback(!callback)
            } else {
                toast.error(res.data);
                setCallback(!callback)
            }
        })
    }

    return (
        <div className='form-container'>
            <div className="table">
                <div className="table_header">
                    <p>Category Details</p>
                    <div>
                        <input
                            type="text"
                            name="search"
                            id="search"
                            placeholder='Search category here...'
                            onChange={(e) => searchHandler(e)}
                        />
                        <Link to="/category-form"><button className="add_new">+ Add New</button></Link>
                    </div>
                </div>

                {
                    categories.count === 0 ? <div className="loading-page-container"><Loading /></div>
                        : <div className="table_section">
                            <table>
                                <thead>
                                    <tr>
                                        <th>Category Code</th>
                                        <th>Name</th>
                                        <th>Description</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        categories.count > 0 ? categories.data.map(category => (
                                            <tr key={category.id}>
                                                <td>{category.category_code}</td>
                                                <td>{category.name}</td>
                                                <td>{category.description}</td>
                                                <td>
                                                    <Link to={`/category-form/${category.id}`}><button><i className="uil uil-edit"></i></button></Link>
                                                    <Link to="#"></Link>
                                                    <button onClick={() => deleteCategoryHandler(category.id)}><i className="uil uil-trash-alt"></i></button>
                                                </td>
                                            </tr>
                                        ))
                                            : <tr>
                                                <td colSpan="4">Can not found any Categories.</td>
                                            </tr>
                                    }
                                </tbody>
                            </table>
                        </div>
                }

                <ReactPaginate
                    breakLabel="..."
                    nextLabel="next >"
                    onPageChange={pageNumberHandler}
                    marginPagesDisplayed={2}
                    pageCount={totalPages}
                    previousLabel="< previous"
                    renderOnZeroPageCount={null}
                    containerClassName='pagination'
                    pageLinkClassName='page-num'
                    previousLinkClassName='page-num'
                    nextLinkClassName='page-num'
                    activeLinkClassName='active-num'
                />
            </div>
            <ToastContainer />
        </div>
    )
}
